import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import ClientDetailModal from "./ClientDetailModal";

const ClientDetail = () => {
  const { clientId } = useParams();
  const navigate = useNavigate();

  return (
    <ClientDetailModal
      isOpen={true}
        clientId={clientId}
      onClose={() => navigate("/portal/asap-pilot/clients")}
    />
  );
};

export default ClientDetail;


